<body>
	<div class="topbar">
		<div class="header-right">
			<ul class="header-menu nav navbar-nav">
				<li class="tour-header">
					<a (click)="startTour()">Take a Tour</a>
				</li>
				<li *ngIf="(grants | async)?.length > 1" class="dropdown scope-header">
					<div id="initialStep1" class="roleWrapper">
						<label for="roleSelect">Role:</label>
						<div class="selectWrapper">
							<select class="inputStyle dropdownInput iconInput arrow-bg" [(ngModel)]="selectedRole"
								(ngModelChange)="selectRole()" name="roleSelect">
								<option *ngFor='let grant of (grants | async)' [value]='grant.grantId'>{{grant.label}}</option>
							</select>
						</div>
					</div>
				</li>
				<li class="dropdown user-header" (click)="userOptions = !userOptions">
					<a data-toggle="dropdown" data-hover="dropdown" data-close-others="true">
						<span class="username">{{currentUser || 'User'}}</span>
						<span class="glyphicon glyphicon-menu-down" aria-hidden="true"></span>
					</a>
					<ul class="dropdown-menu" [ngClass]="{'display-none': !userOptions,'display-block': userOptions}">
						<li (click)="logout()">
							<a>
								<i class="icon-logout"></i>
								<span>Logout</span>
							</a>
						</li>
					</ul>
				</li>
			</ul>
		</div>
	</div>

	<div class="sidebar">
		<div [ngSwitch]="nordfab">
			<div class="logopanel" *ngSwitchCase="true">
				<a href="#">
					<img class="nordfabLogo" src="../assets/images/Nordfab-Logo.png" alt="logo">
				</a>
			</div>
			<div class="logopanel" *ngSwitchDefault>
				<a href="#">
					<img src="../assets/images/Nederman-Logo.png" alt="logo">
				</a>
			</div>
		</div>
		<div class="sidebar-inner">
			<div class="menu-title">
				Navigation
			</div>
			<ul class="nav nav-sidebar">
				<li class="nav-parent">
					<a *appPermission="{roles: ['HoldingAdmin', 'NedermanAdmin']}" id="initialStep2" [routerLink]="[ '/nederman']"
						routerLinkActive="menu-item-clicked">
						<img src="../assets/images/symbols/nederman_symbol.png" alt="nederman">
						<span>Nederman</span>
					</a>
					<ul class="children">
						<li>
							<a [routerLink]="[ '/nederman/companies']" routerLinkActive="menu-item-clicked">Companies</a>
						</li>
						<li>
							<a [routerLink]="[ '/nederman/users']" routerLinkActive="menu-item-clicked">Users</a>
						</li>
					</ul>
				</li>
				<li class="nav-parent">
					<a id="initialStep3" [routerLink]="[ '/customer']" routerLinkActive="menu-item-clicked">
						<img src="../assets/images/symbols/customer_symbol.png" alt="customer">
						<span>Customer</span>
					</a>
					<ul *appPermission="{roles: ['HoldingAdmin', 'NedermanAdmin']}" class="children">
						<li>
							<a [routerLink]="[ '/customer/companies']" routerLinkActive="menu-item-clicked">Companies</a>
						</li>
						<li>
							<a [routerLink]="[ '/customer/users']" routerLinkActive="menu-item-clicked">Users</a>
						</li>
						<li>
							<a [routerLink]="[ '/customer/accounts']" routerLinkActive="menu-item-clicked">ERP Accounts</a>
						</li>
					</ul>
				</li>
				<li *appPermission="{roles: ['HoldingAdmin']}" class="nav-parent">
					<a id="initialStep4" [routerLink]="[ '/applications']" routerLinkActive="menu-item-clicked">
						<img src="../assets/images/symbols/application_symbol.png" alt="application">
						<span>Applications</span>
					</a>
				</li>
				<li *appPermission="{roles: ['HoldingAdmin', 'NedermanAdmin', 'CustomerAdmin']}" class="nav-parent">
					<a id="initialStep5" [routerLink]="[ '/audit']" routerLinkActive="menu-item-clicked">
						<img src="../assets/images/symbols/audit_symbol.png" alt="audit">
						<span>Audit</span>
					</a>
					<ul class="children">
						<li *appPermission="{roles: ['HoldingAdmin']}">
							<a [routerLink]="[ '/audit/erp']" routerLinkActive="menu-item-clicked">ERP Sync</a>
						</li>
						<li>
							<a [routerLink]="[ '/audit/action']" routerLinkActive="menu-item-clicked">Audit Log</a>
						</li>
					</ul>
				</li>
				<li *appPermission="{roles: ['HoldingAdmin'], env: ['development', 'stage', 'sandbox', 'local']}"
					class="nav-parent">
					<a [routerLink]="[ '/explorer' ]" [queryParams]="{shift: 'xxx'}" routerLinkActive="menu-item-clicked">
						<img src="../assets/images/symbols/explorer_symbol.png" alt="explorer">
						<span>Explorer</span>
					</a>
				</li>
			</ul>
		</div>
	</div>

	<div class="main-content">
		<div class="page-content">
			<router-outlet> </router-outlet>
		</div>
	</div>
	<app-error-modal #error="bs-modal"></app-error-modal>
</body>